import { GridCell } from 'shared/components/Grid/GridCell';
import { GridWrapper } from 'shared/components/Grid/styles/GridStyles';
import { IConstructorResult } from 'shared/types/ConstructorResult';
import { WantedProductTemplatesProvider } from 'search/providers/WantedProductTemplatesProvider';

interface IGrid {
  browseKey?: string;
  browseValue?: string;
  currencyRates: { [key: string]: number } | null;
  disableLazyLoad?: boolean;
  globalPricingId: string;
  products: Array<IConstructorResult>;
  resultsCount?: number;
}

export const Grid = ({
  browseKey,
  browseValue,
  currencyRates,
  disableLazyLoad,
  globalPricingId,
  products,
  resultsCount,
}: IGrid) => {
  return (
    <WantedProductTemplatesProvider>
      <GridWrapper>
        {products.map((product, index) => (
          <GridCell
            browseKey={browseKey}
            browseValue={browseValue}
            currencyRates={currencyRates}
            disableLazyLoad={disableLazyLoad}
            globalPricingId={globalPricingId}
            key={product.data.id}
            position={index + 1}
            product={product}
            resultsCount={resultsCount}
          />
        ))}
      </GridWrapper>
    </WantedProductTemplatesProvider>
  );
};
